import { Grid } from "@mui/material";
import { EnumAutocomplete, TextEnumAutocomplete } from "components/alove/EnumAutocomplete";
import { InputType, Question, ResponseType } from "models/batch/Question";

const MDInput = require("components/MDInput/index.js").default;

export const AnswerSettings = ({
    question,
    setQuestion,
}: {
    question: Question;
    setQuestion: Function;
}) => {

    const getFieldParams = (field: string) => {
        return {
            value: question.responseSettings[field] || null,
            onChange: (e: any) => {
                setQuestion({ ...question, responseSettings: { ...question.responseSettings, [field]: e.target?.value || e } });
            }
        }
    }

    return (question.responseType == ResponseType.MultipleChoice ? (<Grid container spacing={2}>
        <Grid size={6}>
            <MDInput
                fullWidth
                label="Max Responses"
                type="number"
                placeholder="The maximum number of responses allowed for this question"
                {...getFieldParams("max_selections")}
            />
        </Grid>
        <Grid size={6}>
            <MDInput
                fullWidth
                label="Min Responses"
                type="number"
                placeholder="The minimum number of responses required for this question for submission"
                {...getFieldParams("min_selections")}
            />
        </Grid>
    </Grid>) : (<Grid container spacing={2}>
        <Grid size={6}>
            <MDInput
                fullWidth
                label="Max Length"
                type="number"
                {...getFieldParams("maxLength")}
            />
        </Grid>
        <Grid size={6}>
            <TextEnumAutocomplete
                enumName={InputType}
                {...getFieldParams('inputType')}
            />
        </Grid>
    </Grid>));
}